import { PrimitiveAtom } from 'jotai';
import { ComponentType, FC, Key } from 'react';

import { useGlobalOverlay } from './useGlobalOverlay';

type WithParamsAndClose<T> = {
    params: T;
    onClose: () => void;
};

export const createGlobalOverlay = <T,>(
    atom: PrimitiveAtom<T | undefined>,
    Component: ComponentType<WithParamsAndClose<T>>,
    getKey?: (params: T) => Key,
): FC => {
    const GlobalOverlay: FC = () => {
        const { params, handleClose } = useGlobalOverlay(atom);

        if (!params) return null;

        return (
            <Component
                key={getKey?.(params)}
                params={params}
                onClose={handleClose}
            />
        );
    };

    return GlobalOverlay;
};
